import React, {useState}							from 'react';

import Input										from '../ressources/components/Input';
import Icon											from '../ressources/components/Icon';
import Modal										from '../ressources/components/Modal';
import ModalFilter									from '../ressources/components/ModalFilter';
import FiltersBadge									from '../ressources/components/ModalFilter/FilterBadge';
import {OrderCard}									from '../ressources/components/Order';
import Button										from '../ressources/components/Button';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';

import {useAppSelector}								from '../app/hooks';
import {Order}										from '../redux/order/interface';
import {InputValues}								from '../ressources/components/Input/interface';
import {FilterChecked}								from '../ressources/components/Modal/interface';

import {ft_replaceSpecialChar}						from '../ressources/functions/search';
import {ft_checkOrderFilters}						from '../ressources/functions/filters';

import img_search									from '../ressources/images/icon/search.svg';
import img_filter									from '../ressources/images/icon/filter.svg';

import LANGUAGE										from '../ressources/language';


interface Props {
	onClose?: () => void,
	onSave: (selectedDevices: string[]) => void,
	onlyOneSelection?: boolean
}


function OrderSelectModal(props: Props) {
	const orders = useAppSelector(state => state.order.data);
	const lang = useAppSelector(state => state.settings.lang);

	const [search, set_search] = useState<InputValues>('');

	const [checkList, set_checkList] = useState<{[key: string]: boolean}>({});
	const [filters, set_filters] = useState<FilterChecked[]>([]);

	const [filterModal, set_filterModal] = useState(false);

	const TEXTE = LANGUAGE(lang);

	function checkBeforeSave() {
		const toArray = Object.entries(checkList).filter(filter => filter[1]);
		const result: string[] = [];

		if (toArray.length === 0 && props.onClose)
			return props.onClose();
		if (toArray.length === 0)
			return props.onSave ? props.onSave([]) : null;

		toArray.forEach((checkedData) => {
			const orderData = orders.find(find => find?._id === checkedData[0]);

			if (orderData)
				result.push(orderData._id);
		});

		if (props.onSave)
			return props.onSave(result);
	}

	function renderOrders() {
		const render: React.ReactElement[] = [];
		let previousOrder: Order;

		orders.forEach((order) => {
			order.addressList.forEach((addressList, i) => {
				if (!order || (search && !ft_replaceSpecialChar(order.number, true, true).includes(ft_replaceSpecialChar(search, true, true))))
					return;
				if (!ft_checkOrderFilters(filters, addressList))
					return;

				render.push(
					<OrderCard
						order={order}
						indexAddressOrder={i}
						addressOrder={addressList}
						style={{alignItems: 'center'}}
						selected={checkList[order._id]}
						checkbox={props.onlyOneSelection ? 'round' : true}
						previousSelected={checkList[previousOrder?._id || ''] || false}
						onClick={() => set_checkList({...(!props.onlyOneSelection && checkList), [order._id]: !checkList[order._id]})}
					/>
				);

				previousOrder = order;
			});
		});

		return (
			<div className={'deviceModalAssignUser'}>
				<div className={'deviceModalAssignUserBody'}>
					{render}
				</div>
			</div>
		);
	}

	return (
		<Modal
			modalRight
			header={TEXTE.order.selectOneOrder}
			confirmButton={checkBeforeSave}
			confirmButtonText={TEXTE.order.chooseThisOrder}
			onClose={() => (props.onClose ? props.onClose() : null)}
		>
			<MultiInputContainer>
				<Input
					value={search}
					onChange={set_search}
					placeholder={TEXTE.users.modal.typeAName}
					before={<Icon icon={img_search} />}
				/>
				<Button type={'tertiary-gray'} iconBefore={img_filter} onClick={() => set_filterModal(true)}>
					{TEXTE.global.filter}
				</Button>
			</MultiInputContainer>

			{filters.length > 0 && <FiltersBadge filters={filters} setFilters={set_filters} />}

			{renderOrders()}

			{filterModal &&
				<ModalFilter
					isOrder
					filters={filters}
					setFilters={set_filters}
					onClose={() => set_filterModal(false)}
				/>
			}
		</Modal>
	);
}

export default OrderSelectModal;
